import { ApiResponse, postRequest } from "@/data/apiClient";

export interface userSelfRegisterRequest {
  userName: string;
  firstName: string;
  lastName: string;
  clientKey: string;
  originalUrl: string | (string | null)[];
}

export interface userSelfRegisterResponse {
  userName: string;
  firstName: string;
  lastName: string;
  clientKey: string;
}

export async function userSelfRegister(
  req: userSelfRegisterRequest
): Promise<ApiResponse<userSelfRegisterResponse>> {
  return postRequest("user/request", req);
}
